import React from "react";
import LoginSection from "../components/sections/LoginSection";
import { Box } from "@mui/material";
import Footer from "../components/layout/Footer";
import fond1 from '../assets/fond1.png';
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Connexion() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectUrl = searchParams.get('redirect');
    return (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundImage: `url(${fond1})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '100vh' }}>
            <Box sx={{ flexGrow: 1, px: 3 }}>
                <img src={require('../assets/logo-no-bg.png')} alt="Logo" style={{ width: '150px', margin: '20px auto', display: 'block' }} />
                <LoginSection {...{onLogin:()=> navigate(redirectUrl??'/')}} />
            </Box>
            <Footer {...{color: 'rgba(255,255,255,0.8)'}}/>
        </Box>
    );
}